import { render, staticRenderFns } from "./ScheduleForm.vue?vue&type=template&id=7d85fa12&scoped=true&"
import script from "./ScheduleForm.vue?vue&type=script&lang=js&"
export * from "./ScheduleForm.vue?vue&type=script&lang=js&"
import style0 from "./ScheduleForm.vue?vue&type=style&index=0&id=7d85fa12&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d85fa12",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCol,VRow,VSwitch,VTextField})
